/**
 * @generated SignedSource<<4b974d76f74ec66baa005b9bc0f8f082>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type useTrackContactVisitMutation$variables = {};
export type useTrackContactVisitMutation$data = {
  readonly trackContactVisit: {
    readonly __typename: "User";
  };
};
export type useTrackContactVisitMutation = {
  response: useTrackContactVisitMutation$data;
  variables: useTrackContactVisitMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "useTrackContactVisitMutation",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "User",
        "kind": "LinkedField",
        "name": "trackContactVisit",
        "plural": false,
        "selections": [
          (v0/*: any*/)
        ],
        "storageKey": null
      }
    ],
    "type": "MutationRoot",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "useTrackContactVisitMutation",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "User",
        "kind": "LinkedField",
        "name": "trackContactVisit",
        "plural": false,
        "selections": [
          (v0/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "c36af28b2fe13c2f9745a4060eaeab9a",
    "id": null,
    "metadata": {},
    "name": "useTrackContactVisitMutation",
    "operationKind": "mutation",
    "text": "mutation useTrackContactVisitMutation {\n  trackContactVisit {\n    __typename\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "f1bd0048b396429455992aa28331d3e1";

export default node;
